var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_vm._v("\n          "+_vm._s(_vm.$t('NF3SC1'))+"\n        ")])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }